
import { Component, Vue, Prop } from "vue-property-decorator";
import { AllVersionAndTagList } from "@/req/game"
@Component
export default class Logout extends Vue {
  @Prop({
    type: Object,
    required: false,
    default: () => ({})
  })public typeId !: any
  public versionId: any = "";
  public tagId: any = "";
  public data: any = [];
  public mounted() {
    this.versionId = this.typeId.versionId;
    this.tagId = this.typeId.tagId;
    this.getAllVersionAndList();
  }

  public async getAllVersionAndList() {
    const obj = {
      token: this.$fn.cookies.getToken(),
    }
    const res = await AllVersionAndTagList(obj);
    this.data = res.data;
  }

  public addVersion(item) {
    if (this.versionId == item.id) {
      this.versionId = "";
      return;
    }
    this.versionId = item.id;
  }
  public addTag(item) {
    if (this.tagId == item.tag_id) {
      this.tagId = "";
      return;
    }
    this.tagId = item.tag_id;
  }

  public confirmData() {
    const typeData = {
      versionId: this.versionId,
      tagId: this.tagId
    }
    this.$emit("confirmData", typeData);
    this.$emit('closePopup', false);
  }
}
